import { ClearanceContent } from "../../components/invoice";

export default function Clearance() {
  return <ClearanceContent />;
}
